export default "__VITE_ASSET__B2eLrrpb__"